<template>
  <div class="newfhkbody">
    <div class="form-check text-center">
      <input class="form-check-input" type="checkbox" v-model="useurl" id="imgmode" />
      <label class="form-check-label" for="imgmode">图片使用外链</label>
    </div>
    <div class="container list">
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-xs-12 card"
          v-for="(doc,index) in docs"
          :key="doc.number"
        >
          <h4>{{index+1}}</h4>
          <!-- <img class="img-fluid" :src="imgUrl+doc.number" /> -->
          <img v-if="useurl" style="width:100%" :src="doc.imgurl" />
          <img v-else style="width:100%" :src="imgUrl+doc.number+'?token='+token" />
          <div>演员：{{doc.actor}}</div>
          <div>番号：{{doc.number}}</div>
          <div>标题：{{doc.title}}</div>
          <div>标签：{{doc.tag}}</div>
          <div v-if="username=='nutbrain'" :class="{'alert':doc.download,'alert-primary':doc.download}">状态：{{doc.download?'已下载':'未下载'}}</div>
          <div>
            <button
              class="btn btn-block"
              :class="{'btn-primary':!favorited(doc)}"
              @click="handleFavorite(doc)"
            >
              <span v-if="favorited(doc)">取消收藏</span>
              <span v-else>收藏</span>
            </button>
          </div>
          <details class="resources">
            <summary>资源列表({{doc.resources.length}})</summary>
            <ul>
              <li v-for="(res,indexR) in doc.resources" :key="res.magnetlink">
                <h6>{{indexR+1}}</h6>
                <div>标题：{{res.name}}</div>
                <div>创建：{{res.date}}</div>
                <div>大小：{{res.formatSize}}</div>
                <div>热度：{{res.hot}}</div>
                <div class="link">
                  磁力：
                  <a :href="res.magnet">{{res.magnet}}</a>
                </div>
                <hr />
              </li>
            </ul>
          </details>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props:[
        'docs','imgUrl','token','username', "favorites"
    ],
    data(){
      return {
        useurl:false
      }
    },
    methods: {
    handleFavorite: function (doc) {
      this.$emit("favorite", doc);
    },
    favorited(doc) {
      return this.favorites.some((f) => {
        return f.number == doc.number;
      });
    },
  },
}
</script>
<style scoped>
.resources{
  font-size:small;
}
li > div {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
  width: 100%;
}
a {
  color: #42b983;
}
</style>